import { render, staticRenderFns } from "./add-official-policy.vue?vue&type=template&id=dd1454aa&scoped=true&"
import script from "./add-official-policy.vue?vue&type=script&lang=js&"
export * from "./add-official-policy.vue?vue&type=script&lang=js&"
import style0 from "./add-official-policy.vue?vue&type=style&index=0&id=dd1454aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1454aa",
  null
  
)

export default component.exports